<template>
  <v-container fluid>
    <v-row class="px-2 mx-4 mt-4">
      <v-btn color="primary" depressed @click="goBack()">
        <v-icon> mdi-chevron-left </v-icon>
      </v-btn>
      <div class="text-h4 pl-4">{{ $t("showSubstance.goBack.search") }}</div>
    </v-row>
    <v-row>
      <v-col lg="10" xl="9">
        <table-result :substances="substances" :headers="headers">
          <v-btn depressed color="secondary" @click="exportResult()">
            {{ $t("searchSubstance.Export") }}
          </v-btn>
        </table-result>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapGetters, mapMutations } from "vuex";
import TableResult from "../components/TableResult.vue";

export default {
  data() {
    return {
      data: [],
      substance: [],
      headers: [],
    };
  },
  computed: {
    ...mapGetters(["lastPage", "currentPage"]),
  },
  beforeMount() {
    if (this.lastPage.name === this.$route.name) {
      this.headers = this.lastPage.params.headers;
      this.substances = this.lastPage.params.substances;
      this.resetLastPage();
      this.setCurrentPage({
        name: this.$route.name,
        params: {
          headers: this.headers,
          substances: this.substances,
        },
      });
    } else if (this.currentPage.name === this.$route.name) {
      this.headers = this.currentPage.params.headers;
      this.substances = this.currentPage.params.substances;
    } else {
      this.initValues();
    }
  },
  components: {
    TableResult,
  },
  methods: {
    ...mapMutations([
      "setLastPage",
      "setCurrentPage",
      "resetLastPage",
      "resetCurrentPage",
    ]),
    initValues() {
      this.data = this.$route.params.results;
      this.substances = [];
      this.headers = [
        {
          text: "Substance / Thématique",
          value: "substance",
          place: 1,
          sortable: false,
        },
      ];
      let tmpheaders = [];
      let place = 1;
      this.data.forEach((sub) => {
        let substance = {};
        sub.rulesbytheme.forEach((theme) => {
          if (tmpheaders.indexOf(theme.theme) < 0) {
            place = place + 1;
            tmpheaders.push(theme.theme);
            this.headers.push({
              text: theme.theme,
              value: theme.theme,
              align: "center",
              sortable: false,
              place: place,
            });
          }
          let prop = theme.theme;
          substance[prop] = {
            qte: theme.count,
            texts: theme.rules,
          };
        });
        substance["substance"] = {
          name: sub.usual_name,
          ce: sub.ce,
          cas: sub.cas,
          id: sub._id,
          count: sub.totalRulesCount,
        };
        this.substances.push(substance);
      });
      this.setCurrentPage({
        name: this.$route.name,
        params: {
          headers: this.headers,
          substances: this.substances,
        },
      });
    },
    async exportResult() {
      try {
        let url = "/substances/nbbytheme";
        let subsID = this.substances.map((sub) => {
          return sub.substance.id;
        });
        const response = await this.axios({
          method: "post",
          url: url,
          data: {
            liste: subsID,
          },
        });
        if (response.status === 200) {
          if (response.data.length) {
            this.setLastPage({
              name: this.$route.name,
              params: {
                headers: this.headers,
                substances: this.substances,
              },
            });
            let substancesToExport = response.data.map((sub) => {
              // return sub;
              let substance = {
                substance: {
                  cas: sub.cas,
                  ce: sub.ce,
                  name: sub.usual_name,
                  id: sub._id,
                },
                rulesNames: [],
              };
              sub.rulesbytheme.forEach((theme) => {
                theme.rules.forEach((rule) => {
                  if (substance.rulesNames.indexOf(rule.name) < 0) {
                    substance.rulesNames.push(rule.name);
                  }
                });
              });
              return substance;
            });
            this.$router.push({
              name: "Export",
              params: { substances: substancesToExport },
            });
          }
        }
      } catch (err) {
        console.log(err);
      }
    },
    goBack() {
      this.resetLastPage();
      this.resetCurrentPage();
      this.$router.push({ name: "SearchMultiRules" });
    },
  },
};
</script>
